import { Component, inject } from '@angular/core';
import {SwUpdate} from "@angular/service-worker";
import { MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';
import { TranslocoModule } from '@ngneat/transloco';

@Component({
    selector: 'app-dialog-update-app',
    templateUrl: './dialog-update-app.component.html',
    styleUrls: ['./dialog-update-app.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton, MatDialogClose, TranslocoModule]
})
export class DialogUpdateAppComponent {
  updates = inject(SwUpdate);


  update() {
    this.updates.activateUpdate().then(() => document.location.reload());
  }
}
